import { UserDTO } from "../models/User";
import { AUTHORITIES } from "./constants";

export const isAslDoctor = (user: UserDTO): boolean =>
  user?.authorities?.some(
    (authority) => authority.name === AUTHORITIES.ASL_DOCTOR
  ) ?? false;

export const isSpecialist = (user: UserDTO) =>
  user?.authorities?.some(
    (authority) => authority.name === AUTHORITIES.SPECIALIST
  ) ?? false;
